import { Component, OnInit } from '@angular/core';

import { NavLink } from '../shared/models/classes/nav-link';
import { NavService } from '../shared/services/nav.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    cards: NavLink[];

    constructor(
        private navSrv: NavService
    ) {}

    ngOnInit() {
        this.setCardsInfos();
    }

    private setCardsInfos(): void {
        const navCards = this.navSrv.getNavLinks().filter(link => link.route !== '/home' && !link.isDisabled);
        const infoCards = this.navSrv.getInfoLinks().filter(link => !link.isDisabled);
        this.cards = navCards.concat(infoCards);
    }
}
